export default "__VITE_ASSET__DyTlCK18__"